module.exports = __webpack_public_path__ + "media/images/Bottom_section-e275118d1672689c7a0e04c3f473277b.png";